var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSortingToggle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.803 12.253a.892.892 0 0 1 .052 1.047l-.079.1-2.912 3.12-.206.203a.916.916 0 0 1-1.316-.003l-.202-.2-2.917-3.125a.885.885 0 0 1-.1-1.038l.076-.106a.665.665 0 0 1 1.018-.027l2.785 2.984 2.785-2.985a.662.662 0 0 1 1.016.03ZM8.343 1.28a.916.916 0 0 1 1.315-.003l.206.203 2.912 3.12.079.1a.892.892 0 0 1-.052 1.047.662.662 0 0 1-1.016.03L9.002 2.792 6.217 5.776a.665.665 0 0 1-1.018-.027l-.076-.106a.885.885 0 0 1 .1-1.038L8.14 1.48Z",
  transform: "translate(-642.000000, -388.000000) translate(642.000000, 388.000000)",
  fill: "#99AFC1",
  fillRule: "evenodd"
})));

export default SvgSortingToggle;